import {pluralize} from 'BenchlingUtil';
import * as EventConstants from 'constants/EventConstants';
import {Section} from 'constants/NavConstants';
import {CheckOutStatus, CICOActionResponse, CICOItemIdsToAssignee} from 'constants/SampleStatusConstants';
import AppDispatcher from 'lib/Dispatcher';
import notifications from 'notifications';
import {getStore} from 'redux-stores/Store';
import * as SearchUIReduxActions from 'search/SearchUIReduxActions';
import {refreshChips} from 'ui-library/chips/useSmartChipQuery';
import APIUtil from 'util/APIUtil';

import * as CICODAO from './CICODAO';

export const CHECKOUT_STATUS_TO_TEXT: {[status in CheckOutStatus]: string} = {
  [CheckOutStatus.AVAILABLE]: 'Checked in',
  [CheckOutStatus.RESERVED]: 'Reserved',
  [CheckOutStatus.CHECKED_OUT]: 'Checked out',
};

function getUniqueItemTypeOrFallback(itemIds: Array<string>): string {
  const itemTypes = [...new Set(itemIds.map((itemId) => APIUtil.apiIdToMaybeType(itemId)))];
  return itemTypes.length === 1 ? itemTypes[0]! : 'item';
}

function dispatchAndNotify(status: CheckOutStatus, itemIdToUpdatedStatusInfo: CICOActionResponse): void {
  AppDispatcher.dispatch({
    actionType: EventConstants.CICO_STATUS_UPDATED,
    itemIdToUpdatedStatusInfo,
  });
  getStore().dispatch(SearchUIReduxActions.forceRefreshSearch(Section.STORAGE));
  getStore().dispatch(SearchUIReduxActions.forceRefreshSearch(Section.SEARCH));
  const itemIds = Object.keys(itemIdToUpdatedStatusInfo);
  refreshChips(itemIds);
  notifications.success(
    `${CHECKOUT_STATUS_TO_TEXT[status]} ${itemIds.length} ${pluralize(
      itemIds.length,
      getUniqueItemTypeOrFallback(itemIds)
    )}`
  );
}

interface ExtraCICOFields {
  comment?: string;
}

export async function checkOut(
  itemIdsToAssignee: CICOItemIdsToAssignee,
  {comment}: ExtraCICOFields
): Promise<void> {
  const actionResponse = await CICODAO.checkOut(itemIdsToAssignee, comment);
  dispatchAndNotify(CheckOutStatus.CHECKED_OUT, actionResponse);
}

export async function checkIn(itemIds: Array<string>, {comment}: ExtraCICOFields): Promise<void> {
  const actionResponse = await CICODAO.checkIn(itemIds, comment);
  dispatchAndNotify(CheckOutStatus.AVAILABLE, actionResponse);
}

export async function reserve(
  itemIdsToAssignee: CICOItemIdsToAssignee,
  {comment}: ExtraCICOFields
): Promise<void> {
  const actionResponse = await CICODAO.reserve(itemIdsToAssignee, comment);
  dispatchAndNotify(CheckOutStatus.RESERVED, actionResponse);
}
